import { render, staticRenderFns } from "./ModalFormularioSedes.vue?vue&type=template&id=01965462"
import script from "./ModalFormularioSedes.vue?vue&type=script&lang=js"
export * from "./ModalFormularioSedes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports